import { Component, OnInit } from '@angular/core';
import { MensagemBanco } from '../_classes/mensagem-banco';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-modal-mensagem-banco',
  templateUrl: './modal-mensagem-banco.component.html',
  styleUrls: ['./modal-mensagem-banco.component.scss']
})
export class ModalMensagemBancoComponent implements OnInit {
  msgs: MensagemBanco[];
  msg: MensagemBanco = null;
  modal: BsModalRef;
  lida: boolean = false;

  constructor() {}

  ngOnInit() {}

  fechar() {
    this.modal.hide();
  }

  ativar() {
    if (this.msgs) {
      if (this.msgs.length > 0) {
        this.msg = this.msgs[0];
      }
    }
  }

  marcarComoLida() {
    if (this.lida) {
      //this.marcarMensagemComoLidaNoServidor(msg);
      //se conseguir gravar, mostrar a proxima
    }
  }
}
